import React from 'react'
import { useRecoilValue } from 'recoil';
import { permissionsSelector } from '../../../Login/selectors/permissionSelector';
import { PERMISSIONS } from '../../../PermissionsConstants';
import EmployeeTitleTable from './view/EmployeeTitleTable';

interface EmpTitleProps {}
export const EmployeeTitle: React.FC<EmpTitleProps> = () => {
    const viewPermission =
    PERMISSIONS.permission_utilities_employeetype_employeetitle_view;
    const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <EmployeeTitleTable />} </>
  );
};
export default EmployeeTitle;